var map = {
	"./add-existing-registry-banner.gif": 1480,
	"./addexistingregistry_379x180_v2.jpg": 772,
	"./addexistingregistry_548x260.jpg": 1481,
	"./computer.png": 515,
	"./computer@2x.png": 1482,
	"./event.png": 291,
	"./event@2x.png": 1483,
	"./faq.png": 1484,
	"./faq@2x.png": 1485,
	"./home.png": 1486,
	"./home@2x.png": 1487,
	"./photo.png": 1488,
	"./photo@2x.png": 1489,
	"./poi.png": 1490,
	"./poi@2x.png": 1491,
	"./registry-video.jpg": 1492,
	"./registry-video@2x.jpg": 1493,
	"./registry.png": 1494,
	"./registry@2x.png": 1495,
	"./registryconversion_zolaintegration.jpg": 1496,
	"./registryconversion_zolaintegration@2x.jpg": 1497,
	"./rsvp.png": 1498,
	"./rsvp@2x.png": 1499,
	"./travel.png": 1500,
	"./travel@2x.png": 1501,
	"./wedding_party.png": 1502,
	"./wedding_party@2x.png": 1503
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1479;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 1479
// module chunks = 47